import { useTranslation } from 'react-i18next';
import Modal from 'shared/ui/modal';
import { CustomButton } from 'shared/ui/custom-button';
import { useUploadTariffBookForm } from '../../hooks/useUploadTariffBookForm';
import {
  MODAL_WIDTH,
  MODAL_MAX_HEIGHT,
} from './modal-upload-tariff-book.constants';
import {
  OrganizationField,
  StartDateField,
  CountryField,
  DiscountSection,
  UploadFileField,
} from './upload-form-fields';

const ModalUploadTariffBook = ({ isOpen, onClose }) => {
  const { t } = useTranslation('common');
  const {
    file,
    formData,
    error,
    hospitalSearch,
    loading,
    fileInputRef,
    countries,
    countryLoading,
    organizations,
    organizationLoading,
    handleFileChange,
    handleSelectCountry,
    handleSearchCountry,
    handleScrollCountry,
    handleOrganizationChange,
    handleOrganizationSearch,
    handleOrganizationClear,
    handleScrollOrganization,
    handleStartingDateChange,
    handleToggleDiscount,
    handleDiscountRuleChange,
    submit,
    closeModal,
  } = useUploadTariffBookForm({ isOpen, onClose });

  return (
    <Modal
      title={t('upload_tariff_book')}
      isOpen={isOpen}
      footer={false}
      closeModal={false}
    >
      <div className={`${MODAL_WIDTH} flex flex-col ${MODAL_MAX_HEIGHT}`}>
        <div className="w-full mb-5 flex flex-col gap-4 items-center overflow-y-auto pr-1">
          <OrganizationField
            value={formData.organization_name}
            error={error?.organization_name}
            disabled={loading}
            organizations={organizations}
            organizationLoading={organizationLoading}
            hospitalSearch={hospitalSearch}
            onSearch={handleOrganizationSearch}
            onChange={handleOrganizationChange}
            onClear={handleOrganizationClear}
            onPopupScroll={handleScrollOrganization}
          />
          <StartDateField
            value={formData?.starting_date}
            error={error?.starting_date}
            disabled={loading}
            onChange={handleStartingDateChange}
          />
          <CountryField
            value={formData.country_id}
            countries={countries}
            countryLoading={countryLoading}
            disabled={loading}
            onSearch={handleSearchCountry}
            onChange={handleSelectCountry}
            onPopupScroll={handleScrollCountry}
          />
          <DiscountSection
            activate={formData.activate_discount_rule}
            value={formData.discount_rule}
            disabled={loading}
            onToggle={handleToggleDiscount}
            onChange={handleDiscountRuleChange}
          />
          <UploadFileField
            file={file}
            loading={loading}
            selectBulkFile={fileInputRef}
            onDraggerChange={handleFileChange}
          />
          {error?.file ? (
            <p role="alert" className="w-full text-left text-error-500">
              {error.file}
            </p>
          ) : null}
        </div>
        <ModalFooter
          loading={loading}
          file={file}
          onCancel={closeModal}
          onUpload={submit}
        />
      </div>
    </Modal>
  );
};

function ModalFooter({ loading, file, onCancel, onUpload }) {
  const { t } = useTranslation('common');

  return (
    <div className="w-full flex justify-end text-center mt-6 gap-2">
      <CustomButton
        type="outline"
        size="sm"
        onClick={onCancel}
        isLoading={loading}
      >
        {t('cancel')}
      </CustomButton>
      <CustomButton
        type="primary"
        size="sm"
        onClick={onUpload}
        disabled={!file}
        isLoading={loading}
      >
        {t('upload_tariff_book')}
      </CustomButton>
    </div>
  );
}

export default ModalUploadTariffBook;
